module.exports = __webpack_public_path__ + "images/the-gambler-dccbc381b854987da7a2283cd28ce25d.png";